import RouteComponent from "@/components/RouteComponent.vue";

export default {
  path: "/esg",
  component: RouteComponent,
  children: [
    {
      path: "eligibility-tests",
      component: RouteComponent,
      children: [
        {
          path: "",
          name: "esg.eligibility-tests.index",
          component: () =>
            import(
              /* webpackChunkName: "esg-eligibility-tests" */ "@/views/esg/EligibilityTestsView.vue"
            ),
          meta: {
            title: "esg.default",
            header: { show: true },
            navbar: { show: true },
            footer: { show: true },
          },
        },
        {
          path: ":compiledEligibilityTestId(\\d+)",
          component: RouteComponent,
          children: [
            {
              path: "questionnaires/:questionnaireOrder(\\d+)",
              component: RouteComponent,
              children: [
                {
                  path: "compilation",
                  name: "esg.eligibility-tests.questionnaires.compilation",
                  component: () =>
                    import(
                      /* webpackChunkName: "esg-questionnaires-compilation" */ "@/views/esg/CompileQuestionnaireView.vue"
                    ),
                  props: true,
                  meta: {
                    title: "esg.questionnaires-compilation",
                    header: { show: true },
                    navbar: { show: true },
                    footer: { show: true },
                  },
                },
                {
                  path: "result",
                  name: "esg.eligibility-tests.questionnaires.result",
                  component: () =>
                    import(
                      /* webpackChunkName: "esg-questionnaires-result" */ "@/views/esg/ResultQuestionnaireView.vue"
                    ),
                  props: true,
                  meta: {
                    title: "esg.eligibility-test-result",
                    header: { show: true },
                    navbar: { show: true },
                    footer: { show: true },
                  },
                },
              ],
            },
            {
              path: "documentations",
              name: "esg.eligibility-tests.documentations",
              component: () =>
                import(
                  /* webpackChunkName: "esg-documentations" */ "@/views/esg/CompliantDocumentationView.vue"
                ),
              props: true,
              meta: {
                title: "esg.documentation",
                header: { show: true },
                navbar: { show: true },
                footer: { show: true },
              },
            },
          ],
        },
      ],
    },
  ],
};
